import * as React from "react";
import * as ReactDOM from "react-dom";

interface IContactFormProps { };

interface IContactFormState {
  subject?: string;
  subjectErrorMessage?: string;
  body?: string;
  bodyErrorMessage?: string;
};

class ContactForm extends React.Component<IContactFormProps, IContactFormState> {
  constructor(props: IContactFormProps) {
    super(props);

    this.state = {
      subject: "",
      subjectErrorMessage: "Inserire al massimo 30 caratteri",
      body: "",
      bodyErrorMessage: "Inserire almeno 10 e al massimo 500 caratteri"
    };

    this.updateSubject = this.updateSubject.bind(this);
    this.updateBody = this.updateBody.bind(this);

    this.isNotSubmittable = this.isNotSubmittable.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  updateSubject(evt: any) {
    let tmpSubject: string = evt.target.value;

    if (tmpSubject.length > 30) {
      this.setState({
        subjectErrorMessage: "Spiacente, al massimo l'oggetto può essere lungo 30 caratteri"
      });
    } else {
      if (this.state.subjectErrorMessage) {
        this.setState({
          subjectErrorMessage: "Inserire al massimo 30 caratteri"
        });
      }

      this.setState({ subject: tmpSubject });
    }
  }

  updateBody(evt: any) {
    let tmpBody: string = evt.target.value;

    if (tmpBody.length > 500) {
      this.setState({
        bodyErrorMessage: "Spiacente, il messaggio deve essere compreso tra 10 e 500 caratteri"
      });
    } else {
      if (this.state.bodyErrorMessage) {
        this.setState({
          bodyErrorMessage: "Inserire almeno 10 e al massimo 500 caratteri"
        });
      }

      this.setState({ body: tmpBody });
    }
  }

  isSubjectCorrect() {
    let subject_length: number = this.state.subject.length;
    return (subject_length > 0 && subject_length <= 30);
  }

  isBodyCorrect() {
    let body_length: number = this.state.body.length;
    return (body_length > 9 && body_length <= 500);
  }

  isNotSubmittable() {
    let subject_length: number = this.state.subject.length;
    let body_length: number = this.state.body.length;

    return (subject_length <= 0 || subject_length > 30) ||
      // sotto i 10 caratteri manco un vaffanculo si sta
      (body_length <= 9 || body_length > 500);
  }

  onFormSubmit(evt: any) {
    evt.target.submit();

    this.setState({
      body: "", bodyErrorMessage: "Inserire almeno 10 e al massimo 500 caratteri",
      subject: "", subjectErrorMessage: "Inserire al massimo 30 caratteri"
    });

    evt.preventDefault();
  }

  render() {
    return <form className="form-horizontal" action="/contactus" method="post" onSubmit={this.onFormSubmit}>
      <div className={this.isSubjectCorrect() ? 'form-group row' : 'form-group row has-error'}>
        <div className="col-12">
          <input
            id="contact-subject"
            className="form-control"
            type="text"
            name="subject"
            onChange={this.updateSubject}
            autoComplete="off"
            placeholder="Oggetto"
            value={this.state.subject} />
          <span
            id="contact-subject-error"
            className="help-block">
            {this.state.subjectErrorMessage}
          </span>
        </div>
      </div>
      <div className={this.isBodyCorrect() ? 'form-group row' : 'form-group row has-error'}>
        <div className="col-12">
          <textarea
            id="control-body"
            className="form-control"
            name="body"
            rows={10}
            autoComplete="off"
            placeholder="Inserisci qui la tua richiesta"
            onChange={this.updateBody}
            value={this.state.body} />
          <span
            id="contact-body-error"
            className="help-block">
            {this.state.bodyErrorMessage}
          </span>
        </div>
      </div>
      <button
        className="btn btn-info pull-right col-12"
        disabled={this.isNotSubmittable()} >
        Invia
      </button>
    </form>;
  }
}

ReactDOM.render(
  <ContactForm />,
  document.getElementById("contact-form")
);
